<template>
  <div>
    <div class="container p-0">
      <section class="home-modules" v-if="!mobileV">
        <div class="row p-0 m-0 g-0">
          <About class="col-md-9 col-sm-12" title="Nosotros" />
          <CardPost class="col-md-3 col-sm-6" />
          <FotoLecturas class="col-md-3 col-sm-6" />
          <HomeSlider class="col-md-6 col-sm-12"/>
          <FotoLectura class="col-md-3 col-sm-6" />
        </div>
        <div class="row p-0 g-0">
          <div class="col-md-9 col-sm-6">
            <div class="row p-0 g-0">
              <Disertaciones class="col-md-4" category="Disertaciones"/>
              <DisertacionesV class="col-md-4"/>
              <DisertacionesVI class="col-md-4"/>
            </div>
          </div>
          <Banner class="col-md-3 col-sm-12" />
        </div>
        <div class="row p-0 g-0">
          <Aliados />
        </div>
      </section>
      <section class="home-modules-mobile" v-if="mobileV">
        <div class="row p-0 m-0 g-0">
          <About title="Nosotros" />
        </div>
        <div class="d-flex flex-row">
          <CardPost class="w-100"/>
          <FotoLecturas class="w-100"/>
        </div>
        <div class="row p-0 m-0 g-0">
          <HomeSlider />
        </div>
        <div class="d-flex flex-row p-0 g-0">
          <Disertaciones class="w-100"/>
          <DisertacionesV class="w-100"/>
        </div>
        <Banner />
        <div class="row p-0 g-0">
          <Aliados />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import About from './About'
import CardPost from './CardPost'
import FotoLecturas from './FotoLecturas'
import FotoLectura from './FotoLectura'
import HomeSlider from './HomeSlider'
import Disertaciones from './Disertaciones'
import DisertacionesV from './DisertacionesV'
import DisertacionesVI from './DisertacionesVI'
import Banner from './Banner'
import Aliados from './Aliados'

export default {
  name: 'Home',
  components: {
    About,
    CardPost,
    FotoLecturas,
    FotoLectura,
    HomeSlider,
    Disertaciones,
    DisertacionesV,
    DisertacionesVI,
    Banner,
    Aliados,
  },
  data() {
    return {
      mobileV: false,
      // Wordpress Posts Endpoint
      postsUrl: "https://foto-urbana.credopop.com/wp-json/wp/v2/posts",
      queryOptions: {
        per_page: 6, // Only retrieve the 10 most recent blog posts.
        page: 1, // Current page of the collection.
        _embed: true //Response should include embedded resources.
      },
      // Returned Posts in an Array
      posts: [],
    };
  },
  methods: {
    // Get Recent Posts From WordPress Site
    getRecentMessages() {
      axios
        .get(this.postsUrl, { params: this.queryOptions })
        .then(response => {
          this.posts = response.data;

          document.title = 'Archivo de Fotografía Urbana';
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleView() {
      this.mobileV = window.innerWidth < 1150;
    },
    getPostDate(date) {
      return moment(date).format("lll");
    }
  },
  mounted() {
    this.getRecentMessages();
  },
  created() {
    this.handleView()
  }
};
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;600;700;900&display=swap');
  @import url('https://pro.fontawesome.com/releases/v5.10.0/css/all.css');

a,
a:visited,
a:active {
  color: #000000;
  opacity: 1;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
}
a:hover {
  color: #000000;
  opacity: 0.5;
  transition: all 0.3s ease-in-out;
  text-decoration: none;
}
.main-module {
    max-width: 1280px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
}
.row .col {
  padding: 0!important;
}

@media only screen and (max-width:1255px){
    .img-aliados{
        height: 120px;
        padding: 10px;
    }
}


@media only screen and (max-width: 1150px){

    .menu{
        display: none;
    }
    .res-menu{
        display: inline !important;
        font-size: 30px;
        padding-top: 10px;
        cursor: pointer;
    }

}

@media only screen and (max-width: 640px){

    .logo-text {
        width: 62px;
        font-family: Raleway;
        font-style: normal;
        font-weight: bold;
        font-size: 10px;
        line-height: 11px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding-left: 9px;
        padding-top: 11px;
    }

    .search {
        width: 160px;
    }

    .title-about{
        width: 100%;
        font-size: 25px;
    }

    .about-afu{
        width: 100%;
        height: 380px;
    }
    .card-post{
        height: auto;
    }
    .img-gradient, .card-post-img-2{
        height: 180px;
    }


    .yellow{
        width: 100% !important;
    }
    .home-slider{
        width: 100%;
        height: auto;
    }
    .slideshow-container {
        height: auto !important;
    }
    .img-aliados{
        height: 90px;
        padding: 1px;
    }
    .footer-container{
        padding-left: 40px;
        flex-direction: column;
    }
    footer{
        height: auto;
    }
}
</style>
